import SvgOptions from "../../../../Components/Svg/SvgOptions";
import AddQuestion from "./AddQuestion/AddQuestion";
import AddTemplate from "./AddTemplate/AddTemplate";
import DeleteTemplate from "./DeleteTemplate/DeleteTemplate";
import RiskTemplateList from "./RiskTemplateList";

const RiskNavOption = [
	{
		element: AddTemplate,
		path: "CreateTemplate",
		access: { user: true, admin: true, super: true },
		Protected: false,
		default: true,
		icon: SvgOptions.Task,
	},
	{
		element: AddTemplate,
		path: "Edit",
		access: { user: true, admin: true, super: true },
		Protected: false,
		default: true,
		icon: SvgOptions.Task,
	},
	{
		element: DeleteTemplate,
		path: "Delete",
		access: { user: true, admin: true, super: true },
		Protected: false,
		default: true,
		icon: SvgOptions.Task,
	},
	{
		element: AddQuestion,
		path: "CreateQuestion",
		access: { user: true, admin: true, super: true },
		Protected: false,
		default: true,
		icon: SvgOptions.Task,
	},
];

const defaultRoute = {
	element: RiskTemplateList,
	path: "*",
	access: { user: true, admin: true, super: true },
	Protected: false,
	default: true,
	icon: SvgOptions.Settings2,
};

export { defaultRoute };
export default RiskNavOption;
